import PageTitle from "../components/PageTitle";
import { ReactComponent as Vector } from "../assets/about/vector01.svg";
import Button from "../components/Button";

export default function Contact(props) {
  return (
    <>
      <PageTitle title={"Contact"} path={["Pages", "Contact Us"]} />
      <div className=" max-w-5xl mx-auto flex mt-20 text-sm">
        <div className=" w-1/2">
          <h2 className=" text-2xl font-fontOne font-bold ">
            Information About Us
          </h2>
          <p className=" text-sub_text_color">
            Proident do excepteur reprehenderit eiusmod nisi. Id consequat
            veniam eiusmod adipisicing ad adipisicing labore aliquip excepteur
            qui proident eu eu. Fugiat ea reprehenderit pariatur ad. Sunt sunt
            sunt pariatur aliquip ea id consectetur. Nisi reprehenderit amet
            consequat nulla pariatur ut excepteur.
          </p>
          <div className="flex mt-6">
            <div className=" w-6 h-6 bg-red-300 rounded-full"></div>
            <div className=" w-6 h-6 bg-blue-300 rounded-full mx-3"></div>
            <div className=" w-6 h-6 bg-teal-300 rounded-full"></div>
          </div>
        </div>
        <div className=" w-1/2">
          <h2 className=" text-2xl font-fontOne font-bold mb-3">Contact Way</h2>
          <div className="grid grid-cols-2">
            <div className="flex items-center mb-6">
              <div className=" rounded-full w-8 h-8 bg-blue-500 mr-2"></div>
              <p className=" text-sub_text_color">
                tel: 743628957289 <br />
                Email: example@mail.com
              </p>
            </div>
            <div className="flex items-center mb-6">
              <div className=" rounded-full w-8 h-8 bg-yellow-500 mr-2"></div>
              <p className=" text-sub_text_color">
                tel: 743628957289 <br />
                Email: example@mail.com
              </p>
            </div>
            <div className="flex items-center mb-6">
              <div className=" rounded-full w-8 h-8 bg-green mr-2"></div>
              <p className=" text-sub_text_color">
                tel: 743628957289 <br />
                Email: example@mail.com
              </p>
            </div>
            <div className="flex items-center mb-6">
              <div className=" rounded-full w-8 h-8 bg-pink mr-2"></div>
              <p className=" text-sub_text_color">
                tel: 743628957289 <br />
                Email: example@mail.com
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* get in touch section */}
      <div className=" max-w-5xl mx-auto flex mt-12 text-sm items-center">
        <div className=" w-1/2">
          <h2 className=" text-2xl font-fontOne font-bold mb-3">Contact Way</h2>
          <p className=" text-sub_text_color mb-4">
            Quis incididunt in excepteur voluptate labore laboris exercitation.
            Elit ipsum id ullamco adipisicing commodo mollit sunt ex sunt
            voluptate nulla duis.
          </p>

          <div className=" flex mb-4">
            <input
              className="mr-2 w-full border p-2 rounded-md focus:outline-none"
              type={"text"}
              placeholder="Your Name"
            />
            <input
              className="mr-2 w-full border p-2 rounded-md focus:outline-none"
              type={"text"}
              placeholder="Your Email"
            />
          </div>
          <input
            className="mb-4 w-full border p-2 rounded-md focus:outline-none"
            type={"text"}
            placeholder="Subject"
          />
          <textarea
            rows={8}
            className="mb-4 w-full border p-2 rounded-md focus:outline-none"
          ></textarea>
          <Button color={"pink"}>Send Mail</Button>
        </div>
        <div className=" w-1/2">
          <Vector className=" w-full" />
        </div>
      </div>
    </>
  );
}
